import { type FC } from 'react';
import {
  UploadSimple
} from '@phosphor-icons/react';
import { UiIcon, type UiIconProps } from './UiIcon';

export type UiIconUsersProps = Omit<UiIconProps, 'IconComponent'>;

export const UiIconUpload: FC<UiIconUsersProps> = (props) => {
  return (
    <UiIcon
      IconComponent={UploadSimple}
      {...props}
    />
  );
};
